import moment from 'moment-timezone';
import { DATETIME_FORMAT, APP_TIMEZONE } from 'common/constants';
import { getId } from 'common/data.utils';

/* eslint-disable camelcase */
export const getNoteDateFormatted = ({ start_time, start_date }) =>
    moment
        .utc(start_time || start_date)
        .tz(APP_TIMEZONE)
        .format(DATETIME_FORMAT);

export const createLogsListItem = (item, category, entityKeyToNameMap) => {
    const { turbine_keys, description, start_date, work_order_id, status } = item;

    let turbineKeys = [];
    try {
        turbineKeys = turbine_keys?.replace(/[\[\]"]/g, '').split(',') || [];
    } catch (error) {
        console.error(error);
    }

    return {
        key:
            category +
            (turbineKeys?.[0] ? turbineKeys[0] : getId(item)) +
            start_date +
            work_order_id +
            status +
            description,
        category,
        formattedDate: getNoteDateFormatted(item),
        label: work_order_id,
        turbineKeys: turbineKeys.map((key) => entityKeyToNameMap[key] || key),
        message: description,
    };
};
